import React from 'react'
import styled from 'styled-components'
import a from '../../Images/PES/a.jpg'
import b from '../../Images/PES/b.jpg';
import c from '../../Images/PES/c.png';
import d from '../../Images/PES/d.jpg';
import e from '../../Images/PES/e.png';
import f from '../../Images/PES/f.png';
import mg1 from '../../Images/MG/mg1.jpg';
import mg2 from '../../Images/MG/mg2.png';
import mg4 from '../../Images/MG/mg4.jpg';
import cv1 from '../../Images/CV/cv1.jpg';
import g from '../../Images/Thumbnails/thumbnails/7k.jpg';
import h from '../../Images/Thumbnails/thumbnails/anje.jpg';
import i from '../../Images/Thumbnails/thumbnails/ce1.jpg';
import j from '../../Images/Thumbnails/thumbnails/ce2.jpg';
import l from '../../Images/Thumbnails/thumbnails/ce4.jpg';
import m from '../../Images/Thumbnails/thumbnails/cjwilson.jpg';
import n from '../../Images/Thumbnails/thumbnails/darius.jpg';
import o from '../../Images/Thumbnails/thumbnails/kykiske.jpg';
import p from '../../Images/Thumbnails/thumbnails/meta.jpg';
import q from '../../Images/Thumbnails/thumbnails/sg.jpg';
import r from '../../Images/Thumbnails/thumbnails/yasuo.jpg';
import s from '../../Images/Thumbnails/thumbnails/yugi.jpg';

export default function Events() {
    return (
        <>
          <Images2>
            <Image2 src={s} alt="yugi"/>
            <Image2 src={r} alt="yasuo"/>
            <Image2 src={q} alt="salamgreat"/>
            <Image2 src={p} alt="rein"/>
            <Image2 src={o} alt="ky"/>
            <Image2 src={g} alt="7k"/>
            <Image2 src={n} alt="darius"/>
            <Image2 src={m} alt="cjwilson"/>
            <Image2 src={l} alt="americanpacific"/>
            <Image2 src={j} alt="christmas"/>
            <Image2 src={i} alt="crunchydrake"/>
            <Image2 src={h} alt="anje"/>
  
          </Images2>
          <Images>
            <Image src={mg1} alt="mg1" /> 
            <Image src={mg2} alt="mg2" />
            <Image src={mg4} alt="mg4" />
            <Image src={a} alt="Image 1" />
            <Image src={b} alt="Image 2" />
            <Image src={c} alt="Image 3" />
            <Image src={d} alt="Image 4" />
            <Image src={e} alt="Image 5" />
            <Image src={f} alt="Image 6" />
            <Image src={cv1} alt="cv 1" /> 
          </Images> 
        </>
    )
}
;

const Images = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-items:center;
  justify-content: center;
  padding-left: 1rem;
  padding-right: 1rem;
`

const Images2 = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-items:center;
  justify-content: center;
  padding-left: 1rem;
  padding-right: 1rem;
`

const Image = styled.img`
  width: 100%;
  height: auto;
  max-width:250px;
  margin: 10px;
  object-fit: cover;
`
const Image2 = styled.img`
  width: 100%;
  height: auto;
  max-width:400px;
  margin: 10px;
  object-fit: cover;
`
